interface Props {
  onClick: () => void;
  variant?: 'inline' | 'cta';
}

export function TimelineAddMilestoneButton({ onClick, variant = 'inline' }: Props) {
  if (variant === 'cta') {
    return (
      <button
        type="button"
        onClick={onClick}
        className="mt-6 inline-flex items-center gap-1 rounded-md border border-dashed border-amber-500/60 bg-amber-50/30 px-3 py-1.5 text-xs font-medium text-amber-700 hover:bg-amber-50 dark:bg-amber-500/5 dark:text-amber-400"
      >
        + Meilenstein hinzufügen
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative ml-6 my-1 inline-flex items-center text-[10px] text-muted-foreground opacity-0 transition-opacity hover:text-amber-700 group-hover:opacity-100"
    >
      + Meilenstein hier
    </button>
  );
}
